
import React, { useState } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import Header from './Header';
import Sidebar from './Sidebar';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // const sidebarWidth = sidebarOpen ? 10 : 10;  

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Header 
        onSidebarToggle={handleSidebarToggle} 
        sidebarOpen={sidebarOpen}
        isMobile={isMobile}
      />
      
      <Sidebar 
        open={sidebarOpen} 
        onToggle={handleSidebarToggle}
        isMobile={isMobile}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          // p: { xs: 2, sm: 3 },
          marginTop: { xs: '56px', sm: '64px' },
          marginLeft: { 
            xs: 0, 
            // md: `${sidebarWidth}px` 
          },
          width: { 
            xs: '100%', 
            // md: `calc(100% - ${sidebarWidth}px)` 
          },
          minHeight: 'calc(100vh - 64px)',
          transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.standard,
          }),
          backgroundColor: 'background.default',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default MainLayout;